import { PasswordActionTypes } from './actionTypes';
import type { PasswordAction } from './actions';

import { type WebData, webDataError, webDataFetching, webDataNotAsked, webDataSuccess } from '@cobliteam/api-lib';

export interface PasswordState {
  changePasswordByRecoveryTokenWebData: WebData<void>;
  forgetPasswordWebData: WebData<void>;
  validateTokenWebData: WebData<void>;
  token: string;
}

export const passwordInitialState: PasswordState = {
  changePasswordByRecoveryTokenWebData: webDataNotAsked(),
  forgetPasswordWebData: webDataNotAsked(),
  validateTokenWebData: webDataNotAsked(),
  token: '',
};

export const passwordReducer = (state: PasswordState = passwordInitialState, action: PasswordAction): PasswordState => {
  switch (action.type) {
    // Password Recovery
    case PasswordActionTypes.CHANGE_PASSWORD_BY_RECOVERY_TOKEN_REQUEST:
      return {
        ...state,
        changePasswordByRecoveryTokenWebData: webDataFetching(),
      };

    case PasswordActionTypes.CHANGE_PASSWORD_BY_RECOVERY_TOKEN_SUCCEEDED:
      return {
        ...state,
        changePasswordByRecoveryTokenWebData: webDataSuccess(undefined),
      };

    case PasswordActionTypes.CHANGE_PASSWORD_BY_RECOVERY_TOKEN_FAILED:
      return {
        ...state,
        changePasswordByRecoveryTokenWebData: webDataError(),
      };

    case PasswordActionTypes.FORGET_PASSWORD_REQUEST:
      return {
        ...state,
        forgetPasswordWebData: webDataFetching(),
      };

    case PasswordActionTypes.FORGET_PASSWORD_SUCCEEDED:
      return {
        ...state,
        forgetPasswordWebData: webDataSuccess(undefined),
      };

    case PasswordActionTypes.FORGET_PASSWORD_FAILED:
      return {
        ...state,
        forgetPasswordWebData: webDataError(),
      };

    case PasswordActionTypes.VALIDATE_TOKEN:
      return {
        ...state,
        token: action.payload.token,
      };
    case PasswordActionTypes.VALIDATE_TOKEN_REQUEST:
      return {
        ...state,
        validateTokenWebData: webDataFetching(),
      };

    case PasswordActionTypes.VALIDATE_TOKEN_SUCCEEDED:
      return {
        ...state,
        validateTokenWebData: webDataSuccess(undefined),
      };

    case PasswordActionTypes.VALIDATE_TOKEN_FAILED:
      return {
        ...state,
        validateTokenWebData: webDataError(),
      };

    case PasswordActionTypes.LOGIN_RESET_STATE:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};
